<template>
  <section>
    <router-view :data="data" name="contractManagement" v-on="$listeners" />
  </section>
</template>

<script>
export default {
  name: 'WrapperContractProvider',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    companyId: {
      type: Number,
      default: () => null,
    },
  },
};
</script>
